import React, { useState } from 'react';
import './firstViewBackGround.module.scss';
import classNames from 'classnames';
import { useElementMetrics } from '../../../../commonv3/hooks/useElementMetrics';

export const FirstViewBackground = ({ isMobile }) => {
    const [ref, setRef] = useState(null);
    const metrics = useElementMetrics(ref);
    if (isMobile) {
        const fitWidth = metrics && metrics.aspectRatio > 9 / 16;
        return (
            <div styleName="video-wrapper" ref={setRef}>
                <video styleName={classNames('video', { 'fit-width': fitWidth })} loop playsInline autoPlay muted>
                    <source
                        src="https://d1ebvx38eov6vd.cloudfront.net/static/likes_top_sp_trimmed.mp4"
                        type="video/mp4"
                    />
                </video>
            </div>
        );
    }
    const fitWidth = !metrics || metrics.aspectRatio > 16 / 9;
    return (
        <div styleName="video-wrapper" ref={setRef}>
            <video styleName={classNames('video', { 'fit-width': fitWidth })} loop playsInline autoPlay muted>
                <source src="https://d1ebvx38eov6vd.cloudfront.net/static/likes_top.mp4" type="video/mp4" />
            </video>
        </div>
    );
};
